angular.module('app.filters').filter('trackingLink', () => {
    return function(trackingNumber) {
        console.log(trackingNumber.length)
        switch (trackingNumber.length) {
            case 10:
                return `https://www.dhl.com/content/g0/en/express/tracking.shtml?AWB=${trackingNumber}&brand=DHL`
            case 12:
            case 15:
                return `https://www.fedex.com/apps/fedextrack/index.html?tracknumbers=${trackingNumber}`;
            case 20:
            case 21:
            case 22:
                return `https://tools.usps.com/go/TrackConfirmAction?qtc_tLabels1=${trackingNumber}`
            default:
                return ""
        }
    }
});


// WEBPACK FOOTER //
// ./filters/tracking_link.js